import React, { useRef } from 'react'
import { QuickGlanceOverlay, Button, useOverlay, IconButton, FlowGrid, DescriptionTooltip } from '@fs/zion-ui'
import { DocumentBasic, MenuMore, ThingHandwriting, PersonRemove, ContentAttach } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'
import { trackEvent } from '@fs/zion-analytics'
import HandwritingOverlay from '../../../../components/handwriting/HandwritingOverlay'
import usePrisonAccess from '../../../../../Give/hooks/usePrisonAccess'

export default function HiddenMenu({
  handleClickRecordDetails,
  handleClickAttachToTree,
  handleSave,
  imageAuth = false,
  showNotAPerson = true,
  showRecordDetails = true,
}) {
  const [t] = useTranslation()
  const menuOverlay = useOverlay()
  const menuRef = useRef()
  const handleClickMenu = () => {
    menuOverlay.handleClick()
  }
  const handwritingOverlay = useOverlay()
  const { accessFromPrison, isReady } = usePrisonAccess()

  return (
    <>
      <IconButton
        title={t('navigation.menu-button', 'More Tools')}
        Icon={MenuMore}
        onClick={handleClickMenu}
        color="gray"
        size="md"
        ref={menuRef}
      />
      <QuickGlanceOverlay {...menuOverlay} placement="start" targetRef={menuRef}>
        <FlowGrid columnCount={1} orientation="vertical" gutters="pico">
          {showNotAPerson && (
            <DescriptionTooltip
              target={
                <Button Icon={PersonRemove} emphasis="low" fullWidth onClick={() => handleSave({}, 'WORD')}>
                  {t('report-error-overlay.not-a-person-button', 'Not A Person')}
                </Button>
              }
              label="NotAPerson"
              description={t(
                'navigation.not-a-person-tooltip',
                'Sometimes the computer identifies text as a name but it may actually be a note from the census taker. Hint: Common text such as "Vacant", "No One Home", etc.'
              )}
            />
          )}

          {showRecordDetails && imageAuth && !accessFromPrison && isReady && (
            <Button Icon={DocumentBasic} emphasis="low" fullWidth onClick={handleClickRecordDetails}>
              {t('navigation.details-button', 'Record Details')}
            </Button>
          )}
          {showRecordDetails && imageAuth && !accessFromPrison && isReady && (
            <Button
              Icon={ContentAttach}
              title={t('attach.header', 'Attach To Tree')}
              onClick={() => handleClickAttachToTree()}
              data-testid="attach-to-tree"
              linkName="Attach To Tree"
            >
              {t('attach.header', 'Attach To Tree')}
            </Button>
          )}
          <Button
            Icon={ThingHandwriting}
            emphasis="low"
            fullWidth
            onClick={() => {
              trackEvent({
                event_name: 'click_action',
                link_name: `Handwriting Help`,
              })
              handwritingOverlay.handleClick()
            }}
          >
            {t('task-viewer.handwriting-tooltip', 'Handwriting Examples')}
          </Button>
          <HandwritingOverlay {...handwritingOverlay} />
        </FlowGrid>
      </QuickGlanceOverlay>
    </>
  )
}
